/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'dollar-sign-circle': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="none" _stroke="#666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7.36743 11.2858C7.36743 11.2858 7.36743 12.5919 9.20253 12.5919C11.5013 12.5919 11.5013 9.46371 9.20253 9.00004C6.90376 8.53637 6.90376 5.4082 9.20253 5.4082C10.6327 5.4082 10.6327 6.71433 10.6327 6.71433" /><path d="M9.32642 4.10156V5.40769" /><path d="M9.32642 12.5918V13.8979" /><path d="M8.99995 16.5106C13.1477 16.5106 16.5102 13.1482 16.5102 9.00044C16.5102 4.85267 13.1477 1.49023 8.99995 1.49023C4.85218 1.49023 1.48975 4.85267 1.48975 9.00044C1.48975 13.1482 4.85218 16.5106 8.99995 16.5106Z" /></g>'
  }
})
